import { SVGProps, Ref, forwardRef } from 'react';

export const RabotaByAppGrayscaleSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.176 1c2.038 0 3.058 0 3.837.396a3.64 3.64 0 0 1 1.59 1.591C15 3.766 15 4.786 15 6.824v2.352c0 2.038 0 3.058-.396 3.837a3.64 3.64 0 0 1-1.591 1.59C12.234 15 11.214 15 9.176 15H6.824c-2.038 0-3.058 0-3.837-.396a3.64 3.64 0 0 1-1.59-1.591C1 12.234 1 11.214 1 9.176V6.824c0-2.038 0-3.058.396-3.837a3.64 3.64 0 0 1 1.591-1.59C3.766 1 4.786 1 6.824 1z"
            fill="#919191"
        />
        <path
            d="M12.021 7.14c0-.348-.077-.691-.226-1.012a2.6 2.6 0 0 0-.643-.857 3 3 0 0 0-.962-.573 3.3 3.3 0 0 0-1.136-.2H4.157V11.5h2.002V9.78h2.4L9.876 11.5h2.145L10.46 9.467a2.86 2.86 0 0 0 1.14-.972c.276-.41.421-.878.422-1.356m-2.967.859H6.16v-1.72h2.895c.531 0 .965.387.965.86S9.585 8 9.054 8"
            fill="#E2E2E2"
        />
    </svg>
));
RabotaByAppGrayscaleSize16Glyph.displayName = 'RabotaByAppGrayscaleSize16Glyph';
